import { render, staticRenderFns } from "./PatientPlanEditComponent.vue?vue&type=template&id=4d308d76&scoped=true"
import script from "./PatientPlanEditComponent.vue?vue&type=script&lang=ts"
export * from "./PatientPlanEditComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d308d76",
  null
  
)

export default component.exports